import React from "react";
import PropTypes from "prop-types";

/**
 * List of accepted icon sizes
 */
export const allowedIconSizes = {
  small: 16,
  standard: 24,
  large: 48,
  extralarge: 64
};

export const allowdBlockIconSizes = {
  small: 16,
  standard: 32
};

/**
 * Returns the nearest, most appropriate allowed
 * file icon size
 * @param {Int} size
 */
const getAllowedFileIconSize = (size, isBlock) => {
  const iconSizes = Object.values(
    isBlock ? allowdBlockIconSizes : allowedIconSizes
  );
  const closest = iconSizes.reduce(
    (previous, current) =>
      Math.abs(current - size) < Math.abs(previous - size) ? current : previous
  );

  return closest;
};

/**
 * OrganizerFileIcon: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Represents a file icon for a specified
 * file type
 *
 * @param {*} props
 */
const OrganizerFileIcon = props => (
  <div className="or-file-icon">
    <img
      src={`/assets/${props.block ? "block" : "file"}types/${
        props.documentType
      }-${getAllowedFileIconSize(props.size, props.block)}.png`}
      width={props.size}
      alt=""
    />
  </div>
);

OrganizerFileIcon.propTypes = {
  documentType: PropTypes.string.isRequired,
  size: PropTypes.number,
  block: PropTypes.bool
};

OrganizerFileIcon.defaultProps = {
  size: 24,
  block: false
};

export default OrganizerFileIcon;



// WEBPACK FOOTER //
// ./src/modules/organizer/view/OrganizerFileIcon.js